import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';

import styled from 'styled-components';
import { withT } from '../context/t';
import Text from './Text';

const getPixelOffset = ({ y_pos }) => (y_pos ? y_pos + 'px' : '0px');

const InfoContainer = styled.div`
  margin-top: ${getPixelOffset};
`;

class InfoBox extends Component {
  constructor(props) {
    super(props);

    this.parentDiv = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.parentDiv);
  }

  componentWillUnmount() {
    document.body.removeChild(this.parentDiv);
  }

  renderBox() {
    const { isOpen, y_pos = 0, subject } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <Fragment>
        <InfoContainer className="info-box" y_pos={y_pos}>
          <button className="info-box__close-btn" onClick={this.props.onClose}>
            <i className="fas fa-times" />
            <span className="sr-only">
              {this.props.t('interface:closeButton')}
            </span>
          </button>
          <h4 className="info-box__title mb-2">{subject}</h4>
          <p className="info-box__text">
            <Text i18nKey={`${subject}.explanation`} />
          </p>
        </InfoContainer>
      </Fragment>
    );
  }

  render() {
    return ReactDOM.createPortal(
      this.renderBox(),
      this.props.container || this.parentDiv
    );
  }
}

export default withT('glossary')(InfoBox);
